import React, { useRef, useState } from 'react';
import classnames from 'classnames';
import { CmsEntities } from 'client/data/models/cms';
import PropTypes from 'prop-types';
import { useOnScreen } from 'site-modules/shared/hooks/use-on-screen';
import { getImageLink } from 'site-modules/editorial/components/top-rated/winner-tiles-nav/get-image-style';
import { LaurelIcons } from 'site-modules/editorial/components/top-rated/icons/laurel-icons';
import { getFullImageUrl } from 'client/utils/image-helpers';

export function BestOfTheBest({ tileEntry, index = 0, isMobile = false, year = null }) {
  const [isIntersecting, setIsIntersecting] = useState(false);
  const ref = useRef();
  const [isOnScreen] = useOnScreen(ref, {
    root: null,
    rootMargin: '0px',
    threshold: 0.1,
  });
  const vehicleTitleToUse = tileEntry
    .metadata('vehicleTitle')
    .value()
    .replace(/^\d{4}/, '')
    .trim();

  if (isOnScreen && !isIntersecting) {
    setIsIntersecting(true);
  }

  return (
    <section className={`winner-tile-${index + 1} mb-1_5 mb-md-0 winner-tile text-center`}>
      <div
        className={classnames('image-container w-100 d-flex', {
          'best-of-the-best-teaser': !tileEntry.metadata('ctaCopy').value(),
          'is-intersecting': isIntersecting && !tileEntry.metadata('ctaCopy').value(),
        })}
      >
        <img src={getFullImageUrl(getImageLink(isMobile, tileEntry).href, 700)} alt="" width="100%" />
      </div>
      <header className="pos-a top-0 left-0 w-100 h-100 winner-description d-flex flex-column align-items-center mt-sm-1 mt-md-2 pt-3">
        <LaurelIcons maxWidth="490px" />
        <div className="text-yellow-05 fw-medium">
          <span className="hidden-md-down size-24 mb-0_25">{year}</span>
          <span className="hidden-md-up size-14">{year}</span>
        </div>
        <div className="category-title px-0_75 pt-0_25 pb-md-0_5 text-yellow-05 fw-bold" ref={ref}>
          <span className="hidden-md-down size-36">{tileEntry.metadata('categoryTitle').value()}</span>
          <span className="hidden-md-up size-20 px-0_5">{tileEntry.metadata('categoryTitle').value()}</span>
        </div>
        <div
          className={classnames('vehicle-title text-yellow-05 fw-medium', {
            'mb-1': vehicleTitleToUse,
          })}
          ref={ref}
        >
          <span className="hidden-md-down size-24">{vehicleTitleToUse}</span>
          <span className="hidden-md-up size-14">{vehicleTitleToUse}</span>
        </div>
        {tileEntry.metadata('ctaCopy').value() && (
          <a
            className="text-center best-of-the-best-link btn px-0 hidden-lg-down"
            href={tileEntry.metadata('tileURL').value()}
          >
            <span className="px-1_5 py-0_5 text-white">{tileEntry.metadata('ctaCopy').value()}</span>
          </a>
        )}
      </header>
      {tileEntry.metadata('ctaCopy').value() && (
        <a
          className="text-center best-of-the-best-link btn px-0 hidden-lg-up mx-auto mb-3_5"
          href={tileEntry.metadata('tileURL').value()}
        >
          <span className="px-1_5 py-0_5 text-white size-20 fw-bold">{tileEntry.metadata('ctaCopy').value()}</span>
        </a>
      )}
    </section>
  );
}

BestOfTheBest.propTypes = {
  tileEntry: CmsEntities.Content.isRequired,
  index: PropTypes.number,
  isMobile: PropTypes.bool,
  year: PropTypes.string,
};
